import React, { useState, useEffect, useCallback } from 'react'
import { requestAPI, get } from '../../data/api.js'
import Input from '../../generic/Input'
import Button from '../../generic/Button'

export default function SkipCountryDetection(props) {
	const { clientId } = props
	const [skipCountryDetection, setSkipCountryDetection] = useState('')

	const fetchSkipCountryDetection = useCallback(async () => {
		const skipCountryDetectionPattern = await getClientSkipCountryDetection(clientId)
		setSkipCountryDetection(skipCountryDetectionPattern)
	}, [clientId])

	useEffect(() => {
		fetchSkipCountryDetection(clientId)
	}, [clientId, fetchSkipCountryDetection])

	const handleSaveSkipCountryDetection = async () => {
		await updateClientSkipCountryDetection(clientId, skipCountryDetection)
		await fetchSkipCountryDetection(clientId)
	}

	return (
		<div>
			<h2 style={{marginTop: '30px', marginBottom: '20px'}}>Skip country detection</h2>
			<p>Skip country detection for images matching the following suppliers pattern</p>
			<Input
				name='skipCountryDetection'
				placeholder='\yAFP\y|\yAP\y'
				value={skipCountryDetection || ''}
				onChange={e => setSkipCountryDetection(e.target.value)}
			/>
			<Button onClick={handleSaveSkipCountryDetection}>Save</Button>
		</div>
	)
}

function getClientSkipCountryDetection(clientId) {
	return get(`/country-detection/skip-pattern/${clientId}`, 'GET')
}

function updateClientSkipCountryDetection(clientId, pattern) {
	return requestAPI(`/country-detection/skip-pattern/${clientId}`, 'PUT', {
		pattern,
	})
}
